// should be moved to the architecture during next refactors

import { Auth0Error, WebAuth, Management, Auth0UserProfile } from "auth0-js"
import fetch from "node-fetch"
import { UpdateUserParams } from "./auth.interface"
import {
  auth0Audience,
  auth0CustomDomain,
  auth0CustomDomainNoHttp,
  forumClientId,
} from "./constants"

export const getUserData = async (
  id: string | (() => string) | null | undefined,
  accessToken: string
) => {
  const response = await fetch(`${auth0CustomDomain}/api/v2/users/${id}`, {
    method: "GET",
    headers: { Authorization: `Bearer ${accessToken}` },
  })

  return await response.json()
}

export const updateUser = async (
  data: UpdateUserParams,
  id: string | (() => string) | null | undefined,
  token: string
) => {
  const response = await fetch(`${auth0CustomDomain}/api/v2/users/${id}`, {
    method: "PATCH",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })

  return response.json()
}

export const checkSession = async (
  callback: (
    error: Auth0Error | null,
    authResult: AuthResult | undefined
  ) => void,
  redirectUrl: string
) => {
  const apiclient = new WebAuth({
    domain: auth0CustomDomainNoHttp!,
    clientID: forumClientId!,
  })
  return apiclient.checkSession(
    {
      redirectUri: redirectUrl,
      responseType: "token id_token",
      scope: "read:current_user openid profile email",
      audience: auth0Audience,
    },
    callback
  )
}
export const singleLogout = async (redirectUrl: string, userId: string) => {
  const apiclient = new WebAuth({
    domain: auth0CustomDomain!.replace(/^https?:\/\//, ""),
    clientID: forumClientId!,
  })
  fetch(`/.netlify/functions/logout-forum`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id: userId }),
  })
  apiclient.logout({
    returnTo: redirectUrl,
  })
}

export const authorize = (redirectUrl: string, language: string): void => {
  const auth0 = new WebAuth({
    domain: auth0CustomDomain!,
    clientID: forumClientId!,
  })
  auth0.authorize({
    audience: auth0Audience,
    scope:
      "update:current_user_metadata read:current_user update:users update:users_app_metadata openid profile email",
    responseType: "code",
    redirectUri: redirectUrl,
    language,
  })
}

export const fetchUserSilent = (
  accessToken: string,
  userId: string,
  callbackSuccess: (res: Auth0UserProfile) => void
): void => {
  const auth0 = new Management({
    domain: auth0CustomDomainNoHttp!,
    token: accessToken,
    scope: "read:current_user",
  })
  auth0.getUser(userId, (err, res) => {
    if (err) {
      throw new Error(err.code)
    } else {
      callbackSuccess(res)
    }
  })
}
